import styled from 'styled-components';

export const Container = styled.div`
	display: flex;
	gap: 12px;

	> div {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}
`;

export const Img = styled.img`
	width: 80px;
	height: 64px;
	border-radius: 8px;
	object-fit: cover;
`;

export const Title = styled.span`
	display: block;
	margin-bottom: 4px;
	${({ theme }) => theme.typography.headlines.h6};
`;

export const Label = styled.span`
	display: block;
	${({ theme }) => theme.typography.label.small};
`;
